export default __webpack_public_path__ + "static/media/sort.22b84928.svg";